import { loadScript } from "@paypal/paypal-js";

const payment = document.querySelector('#paypal-payment');
const info = document.querySelector('#info');

if (payment) {
    loadScript({"client-id": payment.dataset.clientId, 'currency': payment.dataset.currency})
        .then((paypal) => {
            paypal
                .Buttons({
                    createOrder: (data, actions) => {
                        return actions.order.create({
                            purchase_units: [
                                {
                                    amount: {
                                        currency_code: payment.dataset.currency,
                                        value: payment.dataset.amount
                                    },
                                    description: payment.dataset.description
                                },
                            ],

                        })
                    },
                    onApprove: (data, actions) => {
                        return actions.order.capture().then(function (orderData) {
                            const transaction = orderData.purchase_units[0].payments.captures[0];

                            storePayment(transaction)
                                .then(response => {
                                    if (response.type === 'success') {
                                        info.innerHTML = `${transaction.status} - you will be redirect in 15 seconds...`

                                        setTimeout(function () {
                                            window.location.href = payment.dataset.redirectUrl;
                                        }, 15000);

                                        return;
                                    }

                                    alert(response.message);
                                })
                        })
                    }
                })
                .render("#paypal-payment")
                .catch((error) => {
                    console.error("failed to render the PayPal Buttons", error);
                });
        })
        .catch((error) => {
            console.error("failed to load the PayPal JS SDK script", error);
        });

    function storePayment(transaction)
    {
        return fetch(payment.dataset.storePayment, {
                    method: 'POST',
                    headers: {
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        'payment_public_id': payment.dataset.description,
                        'paypal_id': transaction.id,
                        'status': transaction.status,
                        'amount': transaction.amount.value,
                        'currency': transaction.amount.currency_code
                    })
                })
                .then(response => response.json());
    }
}


